import { render } from "./detail-tax-information.vue?vue&type=template&id=66b215a1&scoped=true&ts=true"
import script from "./detail-tax-information.vue?vue&type=script&lang=ts"
export * from "./detail-tax-information.vue?vue&type=script&lang=ts"

import "./detail-tax-information.vue?vue&type=style&index=0&id=66b215a1&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66b215a1"]])

export default __exports__